import React from 'react';
import { Field } from 'react-final-form';

import { FormCheckbox } from 'components';

const DaySelector = () => (
  <Field
    name="availableDays"
    component={FormCheckbox}
    options={[
      'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday',
    ]}
  />
);

export default DaySelector;
